import React from 'react';
import styled from 'styled-components';
import TeamContainer from '../view/team/container/TeamContainer';

const Team = () => {
  return (
    <Container>
      <TeamContainer />
    </Container>
  );
};

const Container = styled.div``;

export default Team;
